import { OfferCatalogData, WithContext } from "../types/schema.types";
import type { OfferCatalog } from "schema-dts";
import { generateOfferCatalog } from "../utils/schema-generators";

/**
 * Builds Schema.org OfferCatalog structured data
 * @param offerCatalogData - Offer catalog information for schema generation
 * @returns Schema.org OfferCatalog JSON-LD object
 */
export function buildOfferCatalogSchema(
  offerCatalogData: OfferCatalogData
): WithContext<OfferCatalog> {
  const offerCatalogSchema: WithContext<OfferCatalog> = {
    "@context": "https://schema.org",
    ...generateOfferCatalog(
      offerCatalogData.name,
      offerCatalogData.description,
      offerCatalogData.url,
      offerCatalogData.products,
      offerCatalogData.breadcrumbs
    ),
  };

  return offerCatalogSchema;
}
